import Vue from 'vue';
import Vuetify from 'vuetify/lib';
import {NsIcon} from '@nuskin/ns-icon';

import 'vuetify/dist/vuetify.min.css';

Vue.use(Vuetify, {
    icons: {
        dropdown: {
            component: NsIcon,
            props: {
                iconName: 'icon-chevron-down'
            }
        }
    }
});
